import React from 'react';
import { getClassName } from 'utils/ui/classes';

const StatCard = ({ title, children, className, dataTestId }) => (
  <div
    data-testid={dataTestId}
    className={getClassName('px-4 py-5 sm:p-6', className)}>
    <dt data-testid="dt-190ec451" className="text-sm font-normal text-gray-900">{title}</dt>
    <dd
      data-testid="dd-85240566"
      className="mt-1 flex justify-between items-baseline md:block lg:flex">
      {children}
    </dd>
  </div>
);

export default StatCard;
